import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateEstadoExpedientePeritoRequest } from '@models/estadoExpedientePerito/createEstadoExpedientePeritoRequest.model';
import { UpdateEstadoExpedientePeritoRequest } from '@models/estadoExpedientePerito/updateEstadoExpedientePeritoRequets.model';

@Injectable({
  providedIn: 'root'
})
export class EstadoExpedientePeritoService {

  constructor(private http:HttpClient) {
  }

  create(createEstadoExpedientePeritoRequest:CreateEstadoExpedientePeritoRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/EstadoExpedientePerito/Create",createEstadoExpedientePeritoRequest);
  }

  update(updateEstadoExpedientePeritoRequest:UpdateEstadoExpedientePeritoRequest):Observable<any>
  {
    return  this.http.put<any>("/api/EstadoExpedientePerito/Update",updateEstadoExpedientePeritoRequest);
  }

  getAll():Observable<BaseDto[]> {
    return   this.http.get<BaseDto[]>("/api/EstadoExpedientePerito/GetAll");
  }

  getById(id:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/EstadoExpedientePerito/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/EstadoExpedientePerito/Delete?id=" + id);
    else
      return of(null)
  }

}
